// extracted by mini-css-extract-plugin
export default {"icon":"NoItemsPageNotice_icon__c5uaR"};